import type { RootState } from 'src/store';
import getCroppingEnable from '../SceneVariation/selectors/getCroppingEnable';

export const CROPPING_SAVE_TIP = 'End the cropping tool to save your changes.';

export default function getCroppingSaveTip(state: RootState): string {
    return getCroppingEnable(state) ? CROPPING_SAVE_TIP : '';
}
